import React, { useEffect, useState } from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Button,
    Snackbar,
} from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import NavigateNext from '@mui/icons-material/NavigateNext';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import { getPhotos, removeImage, setDefaultPhotoApi } from '../../../../asiosConfig';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef((props, ref) => (
    <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

export const ViewImages = () => {
    const navigate = useNavigate();
    const [approvedPhotos, setApprovedPhotos] = useState({});
    const [defaultPhoto, setDefaultPhoto] = useState({});
    const [nonApprovedPhotos, setNonApprovedPhotos] = useState({});
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPhotoList, setCurrentPhotoList] = useState([]);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [selectedPhotoId, setSelectedPhotoId] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const [openMenuPhotoId, setOpenMenuPhotoId] = useState(null);

    // const token = localStorage.getItem('token');

    const fetchPhotos = async () => {
        const response = await getPhotos();
        if (response.status === 200 || response.status === 201) {
            setApprovedPhotos(response.data.data.approved_photos || {});
            setDefaultPhoto(response.data.data.default_photo || []);
            setNonApprovedPhotos(response.data.data.nonapprovedphoto || {});
        }
    };

    useEffect(() => {
        fetchPhotos();
    }, []);

    const showSnackbar = (message) => {
        setSnackbarMessage(message);
        setSnackbarOpen(true);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const openModal = (photos, index) => {
        // Ensure `photos` is an array
        const photoArray = Array.isArray(photos) ? photos : Object.values(photos);
    
        console.log("Opening modal with photos:", photoArray);
        console.log("Starting at index:", index);
    
        setCurrentPhotoList(photoArray);
        setCurrentPhotoIndex(index);
        setIsModalOpen(true);
    };
    

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleNext = () => {
        console.log("nexy", currentPhotoList);
        
        setCurrentPhotoIndex((prevIndex) => (prevIndex + 1) % currentPhotoList.length);
    };

    const handlePrevious = () => {
        console.log("Previous", currentPhotoList);
        
        setCurrentPhotoIndex((prevIndex) => (prevIndex - 1 + currentPhotoList.length) % currentPhotoList.length);
    };

    const handleSetDefaultPhoto = async (photoId) => {
        try {
            const response = await setDefaultPhotoApi({'photo_id': photoId });
            if (response.status === 200) {
                showSnackbar('Default photo set successfully');
                fetchPhotos();
            } else {
                showSnackbar('Failed to set default photo');
            }
        } catch (error) {
            showSnackbar('Error setting default photo');
        }
    };

    const openConfirmDialog = (photoId) => {
        setSelectedPhotoId(photoId);
        setIsConfirmDialogOpen(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await removeImage({'photo_id': selectedPhotoId });
            if (response.status === 200 || response.status === 201) {
                showSnackbar(response.data.message);
                fetchPhotos();
            } else {
                showSnackbar(response.data.message);
            }
        } catch (error) {
            showSnackbar("Error deleting the photo");
        }
        setIsConfirmDialogOpen(false);
    };

    const handleCancelDelete = () => {
        setIsConfirmDialogOpen(false);
    };

    const toggleMenu = (photoId) => {
        if (openMenuPhotoId === photoId) {
            setOpenMenuPhotoId(null);
        } else {
            setOpenMenuPhotoId(photoId);
        }
    };

    const renderPhotos = (photoObject, label) => {
        return Object.keys(photoObject).map((photoId, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} style={{ position: 'relative' }}>
                <div style={{ position: 'relative', cursor: 'pointer' }}>
                    <img
                        src={photoObject[photoId]}
                        alt={`Photo ${photoId}`}
                        style={{
                            width: '100%',
                            height: '250px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            transition: 'transform 0.3s',
                        }}
                        onClick={() => openModal(Object.values(photoObject), index)}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    />
                    {label === 'DEFAULT' && (
                        <Typography
                            variant="caption"
                            style={{
                                position: 'absolute',
                                bottom: '8px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px'
                            }}
                        >
                            Profile Photo
                        </Typography>
                    )}
                    {label === 'APPROVE' && (
                        <Typography
                            variant="caption"
                            style={{
                                position: 'absolute',
                                bottom: '8px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px'
                            }}
                        >
                            Approved Photo
                        </Typography>
                    )}
                    {label === 'NON_APPROVE' && (
                        <Typography
                            variant="caption"
                            style={{
                                position: 'absolute',
                                bottom: '8px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px'
                            }}
                        >
                            Pending Photo
                        </Typography>
                    )}
                    <IconButton
                        onClick={() => toggleMenu(photoId)}
                        style={{ position: 'absolute', top: '8px', right: '8px', color: 'white' }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    {openMenuPhotoId === photoId && (
                        <div style={{
                            position: 'absolute',
                            top: '40px',
                            right: '8px',
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            zIndex: 1,
                        }}>
                            {label === 'APPROVE' && (
                                <>
                                    <div onClick={() => handleSetDefaultPhoto(photoId)} style={{ padding: '8px', cursor: 'pointer' }}>Set as Default</div>
                                    <div onClick={() => openConfirmDialog(photoId)} style={{ padding: '8px', cursor: 'pointer', color: 'red' }}>Delete</div>
                                </>
                            )}
                            {label === 'NON_APPROVE' && (
                                <div onClick={() => openConfirmDialog(photoId)} style={{ padding: '8px', cursor: 'pointer', color: 'red' }}>Delete</div>
                            )}
                        </div>
                    )}
                </div>
            </Grid>
        ));
    };

    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock" variant="outlined" style={{ borderRadius: '8px', marginBottom: '20px' }}>
                <CardHeader
                    avatar={<ArrowBack sx={{ color: '#FF8008', cursor: 'pointer' }} onClick={() => navigate(-1)} />}
                    title="My Photos"
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '24px', fontWeight: '500' } }}
                />
                <CardContent>
                    {Object.keys(approvedPhotos).length === 0 && Object.keys(nonApprovedPhotos).length === 0 && defaultPhoto.length === 0 ? (
                        <Typography variant="body1" align="center" color="textSecondary">No photos found</Typography>
                    ) : (
                        <Grid container spacing={2} className='my-photos'>
                            {defaultPhoto && Object.keys(defaultPhoto).length > 0 && renderPhotos(defaultPhoto, 'DEFAULT')}
                            {approvedPhotos && Object.keys(approvedPhotos).length > 0 && renderPhotos(approvedPhotos, 'APPROVE')}
                            {nonApprovedPhotos && Object.keys(nonApprovedPhotos).length > 0 && renderPhotos(nonApprovedPhotos, 'NON_APPROVE')}
                        </Grid>
                    )}
                </CardContent>
            </Card>

            <Dialog open={isModalOpen} onClose={closeModal} maxWidth="md" fullWidth
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    '& .MuiPaper-root': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        margin: 0,
                        padding: 0,
                    },
                }}
            >
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: 'fixed',
                            right: 8,
                            top: 8,
                            color: 'white',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {/* <IconButton onClick={handlePrevious} >
                        <NavigateBefore sx={{ fontSize: 40, color: '#fff' }} />
                    </IconButton> */}
                    <img
                        src={currentPhotoList[currentPhotoIndex]}
                        alt="Current"
                        style={{ maxWidth: '80%', maxHeight: '80vh', objectFit: 'contain' }}
                    />
                    {/* <IconButton onClick={handleNext}>
                        <NavigateNext sx={{ fontSize: 40, color: '#fff' }} />
                    </IconButton> */}
                </DialogContent>
            </Dialog>


            <Dialog open={isConfirmDialogOpen} onClose={handleCancelDelete}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to delete this photo?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
                    <Button onClick={handleConfirmDelete} color="secondary">Delete</Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};
